// extracted by mini-css-extract-plugin
module.exports = {"root":"LimitedAccessBanner_root__2W1bx","text":"LimitedAccessBanner_text__MUvEx","button":"LimitedAccessBanner_button__2CIU6"};